import { css, useTheme } from '@emotion/react';
import { DefaultButton } from '~/components/atomic';
import { FullScreenLoading } from '~/components/common';
import {
  useGetAssetFileUrlListMutation,
  useGetAssetMotionListQuery,
} from '~/features/assetStore';
import { useAssetStoreState } from '~/store';
import Card from '../Card/Card';

interface MotionListProps {
  handleSubscriptionClick: () => void;
}

export default function MotionList({
  handleSubscriptionClick,
}: MotionListProps) {
  const theme = useTheme();

  const { data } = useGetAssetMotionListQuery();
  const { mutate, isPending } = useGetAssetFileUrlListMutation();

  const { selectedMotion } = useAssetStoreState((state) => ({
    selectedMotion: state.selectedMotion,
  }));
  const { setSelectedMotion, setAnimationState } = useAssetStoreState(
    (state) => ({
      setSelectedMotion: state.setSelectedMotion,
      setAnimationState: state.setAnimationState,
    }),
  );

  const handleMotionClick = (id: string) => {
    if (isPending) return;

    // if (selectedMotion === id) {
    //   setAnimationState({ type: 'Idle' });
    //   setSelectedMotion('');

    //   return;
    // }

    // mutate(
    //   { id, type: 'motion' },
    //   {
    //     onSuccess(response) {
    //       if (response.result === 1) {
    //         setAnimationState({
    //           type: 'external',
    //           animationName: response.data,
    //         });
    //         setSelectedMotion(id);
    //       }
    //     },
    //   },
    // );
  };

  return (
    <>
      {isPending && <FullScreenLoading />}

      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 16px;
          height: calc(100% - 53px);
          overflow-y: auto;
          ${theme.mixins.scroll.none}

          & > ul {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 16px;
          }
        `}
      >
        <ul>
          {data.map((asset) => {
            const { id, thumbnail, name } = asset;

            const selected = id === selectedMotion;

            return (
              <Card
                key={id}
                id={id}
                imageUrl={thumbnail}
                name={name}
                rating={4.7}
                review_count={1000}
                onClick={() => handleMotionClick(id)}
                selected={selected}
              />
            );
          })}
        </ul>

        <div
          css={css`
            display: flex;
            justify-content: center;
            padding: 24px 0 40px;
          `}
        >
          <DefaultButton
            onClick={handleSubscriptionClick}
            colorType='black'
            isLeftIcon
            leftIconName='Add'
            css={css`
              width: auto;
              padding: 0 24px 0 16px;
            `}
          >
            More
          </DefaultButton>
        </div>
      </div>
    </>
  );
}
